import Vue from 'vue';

// Reaktivni singleton mimo Vuex (stejny vzor jako featureFlags.js) - existuje
// proto, ze registerServiceWorker.js bezi MIMO Vue komponenty a potrebuje
// App.vue nejak rict "nova verze je aktivni".
export const appUpdateState = Vue.observable({
  available: false,
});

// register-service-worker rozhoduje o "updated" callbacku jen podle toho, ze
// instalujici worker dosahl stavu 'installed' A zaroven existuje nejaky
// navigator.serviceWorker.controller (zdroj balicku, neresi controllerchange
// vubec). Diky skipWaiting+clientsClaim (vue.config.js) se ale novy SW aktivuje
// sam na pozadi driv, nez uzivatel banner vubec klikne - a tenhle "dozvuk"
// stejne jedne aktivace umi dolehnout i na CERSTVE reloadnutou stranku (novy
// page load si znovu pripoji listener na jeste dobihajici prechod), takze se
// banner po kliknuti na "obnovit" umel objevit znovu, i kdyz zadna dalsi
// verze mezitim nevysla. appUpdateState je jen in-memory Vue.observable a po
// reloadu se vynuluje, takze bez tohohle by stranka nemela jak poznat "tenhle
// update uz jsem prave vyzvedla reloadem".
const RELOAD_MARKER_KEY = 'pokemonReborn:swReloadedAt';
const RELOAD_GRACE_MS = 20000;

export function notifyUpdateAvailable() {
  const reloadedAt = Number(sessionStorage.getItem(RELOAD_MARKER_KEY));
  if (reloadedAt && Date.now() - reloadedAt < RELOAD_GRACE_MS) {
    sessionStorage.removeItem(RELOAD_MARKER_KEY);
    console.log('[appUpdate] Potlacen dozvuk update udalosti tesne po reloadu (stejna aktivace).');
    return;
  }
  appUpdateState.available = true;
}

export function reloadForUpdate() {
  sessionStorage.setItem(RELOAD_MARKER_KEY, String(Date.now()));
  window.location.reload();
}
